// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","colorBlackA70":"rgba(14, 19, 24, 0.7)","colorWhite":"#fff","colorBrand":"#5a5ae6","mediaCarousel":"_3N95ioHTVPKHR_7_2MMAnG","mediaCarouselItem":"_2hJ7SccBxukYW-nnSfjDb8","selectionIndicator":"_KL579AVBv4uPWwjwa9NF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/mediaCarousel/mediaCarousel.css
// module id = 1060
// module chunks = 0